/**
 * Betfair line-session Run display from DB `orders.runs` (dynamic).
 * Lab: Back → Math.ceil; Lay → Math.floor (integer).
 * Example: 282.5 → Back 283, Lay 282; 95.5 → Back 96, Lay 95.
 * Paint like Match Odds (`odds()`): two decimals — `129.00`.
 * MO / fancy / BM must not use this.
 */
export function lineSessionDisplayRun(
  runs: number,
  side: string | null | undefined,
): number {
  if (!Number.isFinite(runs)) return runs
  const lay = String(side || '').trim().toUpperCase() === 'LAY'
  return lay ? Math.floor(runs) : Math.ceil(runs)
}

export function formatLineSessionDisplayRun(
  runs: number | null | undefined,
  side: string | null | undefined,
): string {
  if (runs == null) return ''
  const n = Number(runs)
  if (!Number.isFinite(n)) return ''
  return lineSessionDisplayRun(n, side).toFixed(2)
}
